import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openModalButtonAriaLabel: {
		id: 'backlog.card-list.work-load-by-assignee.open-modal-button-aria-label',
		defaultMessage: 'Open workload by assignee summary modal',
		description: 'Aria label for open workload by assignee summary modal button',
	},
});
